export enum NoticeType {
  Update = "Update",
  Event = "Event",
  Alert = "Alert",
  Hotfix = "Hotfix",
  BugReport = "BugReport",
}
